import React from 'react';

const Pijl = ({ color = '#FFFFFF' }) => (
	<svg viewBox="0 0 50 50" className="icon pijl">
		<polyline stroke={color} points="27.5,15 17.5,25 27.5,35" fill="none" strokeWidth="4.5" strokeLinecap="round" strokeLinejoin="round"></polyline>
	</svg>
);

export default Pijl;
